// @ts-nocheck
import { BigNumber } from "ethers";
import {
  useSingleCallResult,
  useSingleContractMultipleData
} from "lib/hooks/multicall";
import { useMemo } from "react";

import useActiveWeb3React from "./useActiveWeb3React";
import { useDoubleDownClubContract } from "./useContract";

/**
 * Getting the current DoubleDownClub contract
 */
export default function useDoubleDownClub(): { loading: boolean; balance: BigNumber; tokenIds: BigNumber[] } {
    const { account } = useActiveWeb3React()
    const inputs = useMemo(() => [account ?? undefined], [account])
    const ddcContract = useDoubleDownClubContract(false)
    const balance = useSingleCallResult(ddcContract, 'balanceOf', inputs)
    const idList = useMemo(() => {
        const count = balance?.result?.length > 0 ? balance?.result[0] : 0;
        const resp = [];
        for(let i = 0 ; i < count ; i ++) {
            resp.push([
                account, i
            ])
        }
        return resp;
    }, [balance.result, account]);

    const tokenIds = useSingleContractMultipleData(ddcContract, 'tokenOfOwnerByIndex', idList)
    return useMemo(
        () => ({
            tokenIds: tokenIds.length > 0 ? tokenIds.map((token) => { return token.result?.length > 0 ? token.result[0] : null }) : BigNumber.from('0'),
            balance: balance.result?.[0] ?? BigNumber.from('0'),
            loading: false,
        }),
        [balance.result, tokenIds]
    )
}

export function useTokenURI(tokenIds: BigNumber[]): { images: string[] } {
    const ddcContract = useDoubleDownClubContract(false)
    const idList = useMemo(() => {
        const resp = [];
        for(let i = 0 ; i < tokenIds.length ; i ++) {
            resp.push([
                tokenIds[i]
            ])
        }
        return resp;
    }, [tokenIds]);
    const metadata = useSingleContractMultipleData(ddcContract, 'tokenURI', idList)
    return useMemo(
        () => ({
            images: metadata,
            loading: false,
        }),
        [metadata]
    )
}
